import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        // Replace with your actual API
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_SETTING;
        axios.get(`${apiBaseUrl}${Url}`)
            .then(res => setSettings(res.data))
            .catch(err => console.error('Error fetching settings', err));
    }, []);

    return (
        <SettingsContext.Provider value={settings}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSetting = () => useContext(SettingsContext);
